<template>
  <div class="clearfix my-page-list">
    <!-- <div class="page-search-wrapper bg-white">
      <el-tabs v-model="searchParams.pageMode" @tab-click="handlePageModeClick">
        <el-tab-pane :name="item.value" :disabled="item.disabled" v-for="(item, index) in pageModeList" :key="index">
          <div slot="label"><span class="nav-tabs-label">{{item.label}}</span></div>
        </el-tab-pane>
      </el-tabs>
    </div> -->
    <el-scrollbar class="scroll-wrapper page-list-wrapper">
      <div class="page-content">
        <!-- <div class="my-page-nav-list">
          <div class="my-page-nav-item" @click="doSearch('my')" :class="{active: searchParams.type === 'my'}">
            我的作品({{myCount}})
          </div>
          <div class="my-page-nav-item" @click="doSearch('cooperation')" :class="{active: searchParams.type === 'cooperation'}">
            参与作品({{shareCount}})
          </div>
        </div> -->
        <!--页面列表-->
        <div class="page-item-wrapper" v-loading="loading">
          <div class="page-item">
            <thumbnailPanel :pageType="searchParams.pageMode" @openSetting="openSetting" @fastCreate="fastCreate"/>
          </div>
          <div class="page-item" v-for="(item, index) in pageList" :key="index">
            <thumbnailPanel
                    @refresh="getPageList"
                    @showPreview="showPreviewFn"
                    :pageData="item"
                    :btnList="operationBtn(item.isPublish)"
                    @openSetting="openSetting"/>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <!--预览-->
    <previewPage v-if="showPreview" :pageId="previewId" :pageData="previewPageData" @closePreview="showPreview = false"></previewPage>
    <el-dialog title="模板设置" :visible.sync="settingShow" center width="85%" top="3%">
      <infoEdit v-if="settingShow" :id="settingId" @close="settingShow = false" @save="pageSave"></infoEdit>
    </el-dialog>
  </div>
</template>

<script>
	import thumbnailPanel from '@/components/thumbnail-panel'
	import previewPage from './components/preview'
	import infoEdit from '@/components/infoEdit'

	export default {
		components: {
			thumbnailPanel,
			previewPage,
      infoEdit
		},
		data() {
			return {
				loading: false,
				pageList: [],
				myCount: 0,
				shareCount: 0,
				pageModeList: [],
				searchParams: {
					type: 'my',
					pageMode: 'h5'
				},
				previewId: '',
        previewPageData: {},
				showPreview: false,
        settingShow: false,
        settingId: '',
			}
		},
		computed: {},
		created() {
			this.pageModeList = this.$config.pageModeList;
			this.getPageList();
		},
		methods: {
      fastCreate(){
        this.$prompt('模板名', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(async ({ value }) => {
          if(!value){
            this.$message.error("模板名不能为空");
            return;
          }
          const { status, data } = await this.$axios.post('/exhibitionItemsTemplate/save', {
            name: value,
            remarks: "",
            chargeMethod: 2,
            detailImageUrl: "",
            coverImageUrl: "",
            previewUrl: "",
            templateTypeId: "",
            attributionType: 1,
            attributionUserIds: [],
            mainImageUrl: "",
            priceList: [],
            previewAddress: `${process.env.VUE_APP_PREVIEW_URL}`,
            formatType: 2,
            unityPackageUrl: "",
            webglUrl: "",
            sourceType: 5,
          });
          if(status == 200){
            this.$confirm('创建成功', '提示', {
              confirmButtonText: '编辑模板',
              cancelButtonText: '完成',
              type: 'success'
            }).then(() => {
              this.$router.push({ name: "Editor", query: { templateId: data } });
            }).catch(() => {});
            this.getPageList();
          }else{
            this.getPageList();
          }
        }).catch(() => {});
      },
      deepCopy(obj) {
        if (typeof obj !== "object" || obj === null) {
          return obj;
        }
        let copy = Array.isArray(obj) ? [] : {};
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            copy[key] = this.deepCopy(obj[key]);
          }
        }

        return copy;
      },
      async pageSave(e){
        if(!e){
          this.$message.error("数据获取失败，请刷新页面再试");
          return;
        }
        const submitData = this.deepCopy(e)
        submitData.mainImageUrl = submitData.mainImageUrl.filter((i)=>!!i).join(',');
        const { status, data } = await this.$axios.post('/exhibitionItemsTemplate/save', submitData);
        status == 200 && this.$message.success("操作成功") && (this.settingShow = false);
        if(status == 200 && !submitData.id){
          // submitData.id = data;
          // submitData.previewAddress += submitData.id;
          // await this.$axios.post('/exhibitionItemsTemplate/save', submitData);
          this.$confirm('创建成功', '提示', {
            confirmButtonText: '编辑模板',
            cancelButtonText: '完成',
            type: 'success'
          }).then(() => {
            this.$router.push({ name: "Editor", query: { templateId: data } });
          }).catch(() => {});
          this.getPageList();
        }else{
          this.getPageList();
        }
      },
      openSetting(id){
        if(id){
          this.settingId = id;
        }else{
          this.settingId = ''
        }
        this.settingShow = true;
      },
			// 操作按钮类型，分为我的，我的协作，和已发布的三种状态
			operationBtn(isPublished) {
				let baseBtn = ['edit', 'copyTemplate', 'setTemplate'];
				if (this.searchParams.type === 'my') {
					baseBtn = [...baseBtn, 'cooperation', 'delete']
				}
				if (this.searchParams.type === 'cooperation') {
					baseBtn = [...baseBtn, 'unCooperation']
				}
				if (isPublished) {
					baseBtn = [...baseBtn, 'copyUrl', 'viewPageData']
				} else {
					baseBtn = [...baseBtn, 'publish']
				}
				return baseBtn;
			},
			/**
			 * 搜索我的页面，type: my时搜索我的作品， type: share搜索我参与的作品
			 */
			doSearch(type) {
				this.searchParams.type = type;
				this.getPageList()
			},
			/**
			 * 切换页面类型
			 * */
			handlePageModeClick(val) {
				this.searchParams.pageMode = val.name;
				this.getPageList()
			},
			/**
			 * 获取所有页面
			 */
			getPageList() {
				return this.$API.getMyPages({
          pageSize: 500,
          pageNum: 1,
          sourceType: 5,
        }).then(res => {
					this.pageList = res.data.list || []
          this.myCount = res.data.totalCount;
          this.shareCount = 0; // res.body.myCooperationPageCount;
				})
			},
			async showPreviewFn({id}) {
				// this.previewId = id;
        // const {body} = await this.$API.getPageDetail({pageId: this.previewId});
				// this.previewPageData = data;
				// this.showPreview = true;
        window.open(process.env.VUE_APP_PREVIEW_URL + "?id=" + id);
			}
		}
	}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog {
    background: #2a3354;
  }
  ::v-deep .el-dialog__title {
    color: #ffffff;
  }
  ::v-deep .el-dialog .el-dialog__body *{
    color: #ffffff;
  }
  ::v-deep .el-dialog .el-dialog__body .el-input__inner{
    background: #3d4563;
    border: 0;
  }
  .my-page-list {
    height: 100%;
  }

  .page-list-wrapper {
    height: 100%;
  }

  .my-page-nav-list {
    height: 40px;
    line-height: 40px;
    z-index: 2;
    margin-bottom: 20px;
    .my-page-nav-item {
      float: left;
      padding-right: 32px;
      text-align: center;
      cursor: pointer;
      &.active {
        color: $primary;
      }
      &:hover {
        color: $primary;
      }
    }
  }

  .full-input-w {
    width: 100%;
  }

  .nav-tabs-label {
    display: inline-block;
    padding: 0 16px;
    height: 60px;
    line-height: 60px;
  }

  .page-search-wrapper {
    padding: 0;
  }

  .page-item-wrapper {
    .page-item {
      float: left;
      margin-right: 20px;
      margin-bottom: 40px;
    }
  }
</style>
<style lang="scss">
  .my-page-list {
    .page-search-wrapper {
      .el-tabs__header {
        margin: 0;
      }
      .el-tabs__nav-wrap {
        padding: 0 30px;
      }
    }
  }
</style>
